import { createContext, useContext } from 'react';

export interface SynthAgentDrawerContextValue {
  /** Open the agent details side panel for the given agent id. */
  openAgentDrawer: (agentId: string | number) => void;
  /** True only when a provider is mounted (so consumers can hide the action otherwise). */
  canOpen: boolean;
}

export const SynthAgentDrawerContext = createContext<SynthAgentDrawerContextValue>({
  openAgentDrawer: () => {},
  canOpen: false
});

export function useSynthAgentDrawer(): SynthAgentDrawerContextValue {
  return useContext(SynthAgentDrawerContext);
}
